import { render, staticRenderFns } from "./rituals.vue?vue&type=template&id=fa3dd72c"
import script from "./rituals.vue?vue&type=script&lang=js"
export * from "./rituals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports